import React, { Component } from "react";
import axios from "axios";
import { LangContext } from "../LangContext.jsx";

class MassiveDossierReplace extends Component {
    static contextType = LangContext;

    constructor(props) {
        super(props);
        this.state = {
            dossiers: [],
            selectedDossierId: '',
            file: null,
            loading: false,
            results: null,
            error: null,
            search: '',
            history: [],
            rollbackLoadingId: null,
        };
    }

    componentDidMount() {
        this.loadDossiers();
        this.loadHistory();
    }

    loadDossiers = async () => {
        const query = new URLSearchParams();
        if (this.state.search) {
            query.append('search', this.state.search);
        }

        const response = await axios.get(`/api/dossiers_to_replace/massive/templates?${query.toString()}`);
        this.setState({ dossiers: response.data });
    }

    loadHistory = async () => {
        const response = await axios.get('/api/dossiers_to_replace/massive/history');
        this.setState({ history: response.data });
    }

    handleSearch = (event) => {
        this.setState({ search: event.target.value }, () => this.loadDossiers());
    }

    handleSubmit = async (event) => {
        event.preventDefault();

        if (!this.state.selectedDossierId || !this.state.file) {
            this.setState({ error: 'Selecciona la plantilla destino y sube un archivo con RFCs.' });
            return;
        }

        const selectedDossier = this.state.dossiers.find((dossier) => String(dossier.id) === String(this.state.selectedDossierId));

        const confirmed = await swal.fire({
            text: `Se reemplazarán todos los expedientes de los RFCs del archivo por “${selectedDossier?.title || 'la plantilla seleccionada'}”. No se conservará ningún documento o archivo anterior.`,
            showCancelButton: true,
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: 'Reemplazar',
            cancelButtonText: 'Cancelar',
            customClass: {
                confirmButton: "btn font-weight-bold btn-danger",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        });

        if (!confirmed.isConfirmed) {
            return;
        }

        const formData = new FormData();
        formData.append('replace_id', this.state.selectedDossierId);
        formData.append('file', this.state.file);

        this.setState({ loading: true, error: null, results: null });
        window.blockUI && window.blockUI();

        try {
            const response = await axios.post('/api/dossiers_to_replace/massive', formData);

            this.setState({ results: response.data });
            await this.loadHistory();

            swal.fire({
                text: response.data.message,
                icon: response.data.summary.failed > 0 ? "warning" : "success",
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        } catch (error) {
            console.error('massive_dossier_replace.error', error);
            const errors = error.response?.data?.errors;
            const firstError = errors ? Object.values(errors).flat()[0] : null;
            const message = error.response?.data?.message
                || firstError
                || error.response?.data?.detail
                || (error.response?.status ? `No se pudo procesar el reemplazo masivo. Código HTTP: ${error.response.status}.` : null)
                || 'No se pudo procesar el reemplazo masivo. El servidor no respondió; revisa logs del backend.';
            this.setState({ error: message });
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        } finally {
            this.setState({ loading: false });
            window.unblockUI && window.unblockUI();
        }
    }

    rollbackReplacement = async (replacement) => {
        const confirmed = await swal.fire({
            text: `Se revertirá el proceso ${replacement.run_id}. Los documentos nuevos se enviarán a papelera y se restaurarán los documentos anteriores.`,
            showCancelButton: true,
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: 'Rollback',
            cancelButtonText: 'Cancelar',
            customClass: {
                confirmButton: "btn font-weight-bold btn-danger",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        });

        if (!confirmed.isConfirmed) {
            return;
        }

        this.setState({ rollbackLoadingId: replacement.id, error: null });
        window.blockUI && window.blockUI();

        try {
            const response = await axios.post(`/api/dossiers_to_replace/massive/${replacement.id}/rollback`);
            await this.loadHistory();
            swal.fire({
                text: response.data.message || 'Rollback terminado.',
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        } catch (error) {
            const message = error.response?.data?.message || 'No se pudo revertir el proceso.';
            this.setState({ error: message });
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        } finally {
            this.setState({ rollbackLoadingId: null });
            window.unblockUI && window.unblockUI();
        }
    }

    render() {
        return (
            <div>
                <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                    <div className="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap w-100">
                        <div className="d-flex align-items-center flex-wrap mr-1">
                            <div className="d-flex flex-column">
                                <h2 className="text-dark font-weight-bold my-1 mr-5">Reemplazo masivo de expedientes</h2>
                                <span className="text-muted font-weight-bold">Sube un Excel con RFCs y elige la plantilla destino.</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card card-custom gutter-b">
                    <div className="card-body">
                        <div className="alert alert-warning">
                            Este proceso omite el paso de conservación: todos los documentos y archivos anteriores del expediente serán eliminados y se crearán solicitudes nuevas con la plantilla seleccionada.
                        </div>

                        {this.state.error && <div className="alert alert-danger">{this.state.error}</div>}

                        <form onSubmit={this.handleSubmit}>
                            <div className="form-group">
                                <label className="font-weight-bold">Buscar plantilla destino</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Buscar por nombre"
                                    value={this.state.search}
                                    onChange={this.handleSearch}
                                />
                            </div>

                            <div className="form-group">
                                <label className="font-weight-bold">Plantilla destino</label>
                                <select
                                    className="form-control"
                                    value={this.state.selectedDossierId}
                                    onChange={(event) => this.setState({ selectedDossierId: event.target.value })}
                                >
                                    <option value="">Selecciona una plantilla</option>
                                    {this.state.dossiers.map((dossier) => (
                                        <option key={dossier.id} value={dossier.id}>
                                            {dossier.title}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group">
                                <label className="font-weight-bold">Archivo Excel</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    accept=".xlsx,.xls,.csv"
                                    onChange={(event) => this.setState({ file: event.target.files[0] })}
                                />
                                <small className="form-text text-muted">El archivo debe incluir una columna llamada rfc. También se acepta que el RFC venga en la primera columna.</small>
                            </div>

                            <button className="btn btn-primary font-weight-bold" disabled={this.state.loading}>
                                {this.state.loading ? 'Procesando...' : 'Reemplazar expedientes'}
                            </button>
                        </form>
                    </div>
                </div>

                {this.state.history.length > 0 &&
                    <div className="card card-custom gutter-b">
                        <div className="card-header">
                            <h3 className="card-title">Procesos recientes</h3>
                        </div>
                        <div className="card-body">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>ID de proceso</th>
                                        <th>Plantilla destino</th>
                                        <th>Reemplazados</th>
                                        <th>Errores</th>
                                        <th>Estatus</th>
                                        <th>Fecha</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.history.map((replacement) => (
                                        <tr key={replacement.id}>
                                            <td>{replacement.run_id}</td>
                                            <td>{replacement.replacement_dossier?.title || replacement.replace_dossier_id}</td>
                                            <td>{replacement.replaced_count}</td>
                                            <td>{replacement.failed_count}</td>
                                            <td>{replacement.status === 'rolled_back' ? 'Revertido' : replacement.status}</td>
                                            <td>{replacement.created_at}</td>
                                            <td>
                                                {replacement.status === 'completed' ? (
                                                    <button
                                                        type="button"
                                                        className="btn btn-light-danger btn-sm"
                                                        disabled={this.state.rollbackLoadingId === replacement.id}
                                                        onClick={() => this.rollbackReplacement(replacement)}
                                                    >
                                                        {this.state.rollbackLoadingId === replacement.id ? 'Revirtiendo...' : 'Rollback'}
                                                    </button>
                                                ) : (
                                                    <span className="text-muted">Sin acciones</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                }

                {this.state.results &&
                    <div className="card card-custom gutter-b">
                        <div className="card-header">
                            <h3 className="card-title">Resultado</h3>
                        </div>
                        <div className="card-body">
                            <div className="row mb-5">
                                {this.state.results.run_id && <div className="col-md-12 mb-3"><strong>ID de proceso:</strong> {this.state.results.run_id}</div>}
                                <div className="col-md-3"><strong>RFCs:</strong> {this.state.results.summary.rfcs}</div>
                                <div className="col-md-3"><strong>Expedientes encontrados:</strong> {this.state.results.summary.dossiers_found}</div>
                                <div className="col-md-3"><strong>Reemplazados:</strong> {this.state.results.summary.replaced}</div>
                                <div className="col-md-3"><strong>Errores:</strong> {this.state.results.summary.failed}</div>
                            </div>

                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>RFC</th>
                                        <th>Estatus</th>
                                        <th>Detalle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.results.results.map((result, index) => (
                                        <tr key={index}>
                                            <td>{result.rfc}</td>
                                            <td>{result.status}</td>
                                            <td>
                                                {result.message}
                                                {result.dossiers.map((dossier) => (
                                                    <div key={dossier.person_provider_id || dossier.message}>
                                                        Expediente #{dossier.person_provider_id}: {dossier.status}{dossier.message ? ` - ${dossier.message}` : ''}
                                                    </div>
                                                ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default MassiveDossierReplace;
